import { Reducer } from 'redux';
import { UPDATE_ERRORS } from '../actions/actionTypes';
import { CustomError } from '../../models/Error';

export const errorReducer: Reducer<CustomError> = (state = new CustomError(), action) => {
    switch (action.type) {
        case UPDATE_ERRORS:           
            let error = action.payload;
            return error;      
        default:
            return state;
    }
};